
import cloneDeep from 'lodash/cloneDeep'

export const FRONTEND_ID_LIST = 'frontend_id_list'

export function filterRangeDataByCountry(data: any) {
  let target: any = data
  let areaIndex: number = -1
  let countryBreakFlag = false
  let cityBreakFlag = false

  for (let i = 0; i < data.length; i++) {
    if (countryBreakFlag || cityBreakFlag) { break }
    const cur = data[i]
    if (cur.children?.length) {
      for (let j = 0; j < cur.children?.length; j++) {
        const country = cur.children[j]
        if (country.checked) {
          target = country
          countryBreakFlag = true
          areaIndex = i
          break
        }

        if (country.children?.length) {
          for (let k = 0; k < country.children.length; k++) {
            const city = country.children[k]
            if (city.checked) {
              target = country
              cityBreakFlag = true
              areaIndex = i
              break
            }
          }
        }
      }
    }
  }

  if (areaIndex !== -1) {
    const _cur = cloneDeep(target)
    target = data[areaIndex]
    target.children = [_cur]
    return [target]
  }

  return target
}

export function clearAll(data: any) {
  data.forEach((item: any) => {
    item.show = true
    item.checked = false
    item.children && clearAll(item.children)
  })
}
